import PowerIcon from "./PowerIcon";
import CountUp from "./CountUp";

export default function InstantCard(props) {
  const { title, value, unit, color } = props;
  const numericValue = Number(value);
  const isNumeric = Number.isFinite(numericValue);
  return (
    <div
      className={`flex flex-col items-center gap-[6px] rounded-[10px] border-2 bg-[#1A111D] p-3 w-full shadow-md`}
      style={{ borderColor: color }}
    >
      <div className="w-full h-full flex items-center justify-start gap-2">
        <div className="hidden md:flex">
          <PowerIcon color={color} />
        </div>
        <span className="text-white text-[14px] md:text-[18px] font-semibold">
          {title}
        </span>
      </div>
      <span className="text-white text-[16px] md:text-[18px] font-bold w-full flex flex-col lg:flex-row flex-wrap gap-2">
        {isNumeric ? (
          <CountUp
            from={0}
            to={numericValue}
            separator="," 
            direction="up"
            duration={2}
            className="count-up-text"
          />
        ) : (
          <span className="count-up-text">{value ?? "--"}</span>
        )}{" "}
        <span className="text-white text-[16px] md:text-[18px] font-bold">
          {unit}
        </span>
      </span>
    </div>
  );
}
